// @ts-strict-ignore
import { APP_BASE_PATH } from './appBasePath';

const BASE_URL = process.env.CARVANA_APP_BASE_URL;

export type AuthorizedReferrer = {
  breadcrumb?: string;
  match?: string;
  matchFromApp?: boolean;
  name: string;
  pattern?: RegExp;
  url?: string;
};

const authorizedReferrers: AuthorizedReferrer[] = [
  { pattern: /\/acquisition(\S)*/, name: 'purchase', breadcrumb: 'Purchase' },
  { pattern: /\/cars(\S)*/, name: 'search', breadcrumb: 'Search Results' },
  { pattern: /\/procurement(\S)*/, name: 'purchase', breadcrumb: 'Purchase' },
  { pattern: /\/purchase(\S)*/, name: 'purchase', breadcrumb: 'Purchase' },
  { pattern: /\/vehicle\/[0-9]+\/?/, name: 'vehicle', breadcrumb: 'Vehicle' }
];

const getMatch = (
  referrer: string,
  allowedReferrers: AuthorizedReferrer[]
): AuthorizedReferrer | null =>
  allowedReferrers.reduce((acc, { pattern, name, matchFromApp, ...options }) => {
    if (!matchFromApp && referrer.toLowerCase().includes(APP_BASE_PATH)) {
      return acc;
    }
    const match = referrer.match(pattern);
    return match ? { name, match: match[0], url: `${BASE_URL}${match[0]}`, ...options } : acc;
  }, undefined);

const getReferrer = (allowedReferrers = authorizedReferrers): AuthorizedReferrer | null => {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const { referrer } = document;
  if (!referrer.startsWith(BASE_URL)) {
    return undefined;
  }
  return getMatch(referrer, allowedReferrers);
};

export { getReferrer };
